import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import newsletter from "../../assets/images/newsletter.png"
const NewsLetterSubscribe = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <section className="text-mcolor bg-mwhite mt-5" >
                <div className="container px-5 py-20 mx-auto">

                    <div className="grid px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
                        <div className="m-1 lg:m-10 lg:col-span-7">
                            <h1 className=" mb-4 text-xl uppercase
                            font-extrabold text-mcolor font-mfont
                             dark:text-white">newsletter</h1>
                            <h1 className=" mb-4 lg:text-5xl text-4xl uppercase
                            font-extrabold text-mcolor font-mfont
                             dark:text-white">Making Minds Technologies NewsLetter.</h1>
                            <p className="max-w-3xl mb-6 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-lg lg:text-xl dark:text-gray-400">
                                Our monthly newsletter where we share some of our
                                noteworthy business highlights to keep you informed about all things Making Minds Technologies.
                            </p>
                        </div>
                        <div className=" lg:mt-0 lg:col-span-5 lg:flex">
                            <img src={newsletter} alt="newletter" />
                        </div>
                    </div>
                </div>
            </section>

            <div className="mx-auto mt-3 max-w-7xl px-6 mb-10  lg:px-8">
                <div className="relative isolate overflow-hidden bg-mcolor px-6 py-24 shadow-2xl rounded-2xl sm:rounded-3xl sm:px-24 xl:py-32">
                    <h2 className="mx-auto max-w-2xl text-center text-mwhite text-3xl font-bold font-mfont tracking-tight sm:text-4xl">Making Minds Technologies Newsletter
                    </h2>
                    <p className="mx-auto mt-3 mb-3 font-mfont  text-center text-md  text-mwhite">
                        Our monthly newsletter where we share some of our
                        noteworthy business highlights to keep you informed about all things Making Minds Technologies.
                    </p>
                    <form className="">
                        <div className="items-center mx-auto mt-5 mb-3 space-y-4 max-w-screen-sm sm:flex sm:space-y-0">
                            <div className="relative w-full">
                                <label for="email" className="hidden mb-2 text-sm font-medium text-mwhite font-mfont dark:text-gray-300">Email address</label>
                                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                                    <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path></svg>
                                </div>
                                <input className="block p-3 pl-10 w-full text-sm text-mwhite
                                 bg-gray-50 rounded-lg border border-gray-300 sm:rounded-none 
                                 sm:rounded-l-lg focus:ring-blue-500 focus:border-blue-500
                                  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
                                   dark:text-white font-mfont dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter your Email" type="email" id="email" required="" />
                            </div>
                            <div>
                                <button type="submit" className="py-3 font-mfont px-5 w-full text-sm font-medium 
                                text-center text-white rounded-lg border cursor-pointer bg-blue-700 border-blue-600 sm:rounded-none sm:rounded-r-lg
                                 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700
                                  dark:focus:ring-blue-800">Subscribe</button>
                            </div>
                        </div>
                        <div className="mx-auto max-w-screen-sm text-sm text-left text-mwhite font-mfont newsletter-form-footer
                         dark:text-gray-300">We care about the protection of your data. <Link to="/privacypolicy" className="font-medium text-blue-600
                          dark:text-blue-500 hover:underline">Read our Privacy Policy</Link>.</div>
                    </form>
                    <svg viewBox="0 0 1024 1024" className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2"
                        aria-hidden="true">
                        <circle cx="512" cy="512" r="512" fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fill-opacity="0.7">
                        </circle>
                        <defs>
                            <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641" cx="0" cy="0" r="1"
                                gradientUnits="userSpaceOnUse" gradientTransform="translate(512 512) rotate(90) scale(512)">
                                <stop stop-color="#7775D6"></stop>
                                <stop offset="1" stop-color="#7ED321" stop-opacity="0"></stop>
                            </radialGradient>
                        </defs>
                    </svg>

                </div>
            </div>
        </div >
    )
}

export default NewsLetterSubscribe